// NOTICE: KAPTION-INTEGRATION
// Asistentes: with KAPTION_AGENT_PROVIDERS on, the AI Studio sidebar entry is
// replaced by ONE flat group (no nested dropdowns): Resumen, Studio Chat,
// Salesforce Agentforce, Sets (KAPTION_INTERACTIVE_SETS), Configuración. Shared by KaptionSidebar.vue and
// KaptionSidebarV2.vue. Returns null when the sidebar must stay as it is
// today (flag off, or a non-administrator: every Asistentes page is admin-only),
// so the caller falls back to the existing AI Studio entry.

export const KAPTION_ASSISTANTS_SIDEBAR_NAME = 'Kaption Assistants Section';

export const KAPTION_ASSISTANTS_ROUTES = {
  OVERVIEW: 'kaption_assistants_overview',
  SETTINGS: 'kaption_assistants_settings',
  AGENTFORCE: 'kaption_assistants_agentforce',
  AGENTFORCE_CONNECTION: 'kaption_assistants_agentforce_connection',
  AGENTFORCE_BEHAVIOR: 'kaption_assistants_agentforce_behavior',
  AGENTFORCE_ACTIVITY: 'kaption_assistants_agentforce_activity',
  AGENTFORCE_TOOLS: 'kaption_assistants_agentforce_tools',
  AGENTFORCE_TESTS: 'kaption_assistants_agentforce_tests',
  SETS: 'kaption_assistants_sets',
};

export const buildKaptionAssistantsSidebarItem = ({
  isKaptionFlagEnabled,
  isAdmin,
  showStudioChat,
  t,
  accountScopedRoute,
}) => {
  if (!isKaptionFlagEnabled('KAPTION_AGENT_PROVIDERS') || !isAdmin) {
    return null;
  }

  const children = [
    {
      name: 'Kaption Assistants Overview',
      label: t('KAPTION_ASSISTANTS.SIDEBAR.OVERVIEW'),
      to: accountScopedRoute(KAPTION_ASSISTANTS_ROUTES.OVERVIEW),
      activeOn: [KAPTION_ASSISTANTS_ROUTES.OVERVIEW],
    },
  ];

  if (showStudioChat) {
    children.push({
      name: 'Kaption Assistants Studio Chat',
      label: t('KAPTION_ASSISTANTS.SIDEBAR.STUDIO_CHAT'),
      to: accountScopedRoute('ai_studio_index', {}, { section: 'home' }),
      activeOn: ['ai_studio_index'],
    });
  }

  if (isKaptionFlagEnabled('KAPTION_AGENT_PROVIDER_AGENTFORCE')) {
    children.push({
      name: 'Kaption Assistants Agentforce',
      label: t('KAPTION_ASSISTANTS.SIDEBAR.AGENTFORCE'),
      to: accountScopedRoute(KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_CONNECTION),
      activeOn: [
        KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_CONNECTION,
        KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_BEHAVIOR,
        KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_ACTIVITY,
        KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_TOOLS,
        KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_TESTS,
      ],
    });
  }

  if (isKaptionFlagEnabled('KAPTION_INTERACTIVE_SETS')) {
    children.push({
      name: 'Kaption Assistants Sets',
      label: t('KAPTION_ASSISTANTS.SIDEBAR.SETS'),
      to: accountScopedRoute(KAPTION_ASSISTANTS_ROUTES.SETS),
      activeOn: [KAPTION_ASSISTANTS_ROUTES.SETS],
    });
  }

  children.push({
    name: 'Kaption Assistants Settings',
    label: t('KAPTION_ASSISTANTS.SIDEBAR.SETTINGS'),
    to: accountScopedRoute(KAPTION_ASSISTANTS_ROUTES.SETTINGS),
    activeOn: [KAPTION_ASSISTANTS_ROUTES.SETTINGS],
  });

  return {
    name: KAPTION_ASSISTANTS_SIDEBAR_NAME,
    label: t('KAPTION_ASSISTANTS.SIDEBAR.GROUP'),
    icon: 'i-lucide-sparkles',
    activeOn: [
      ...Object.values(KAPTION_ASSISTANTS_ROUTES),
      ...(showStudioChat ? ['ai_studio_index'] : []),
    ],
    children,
  };
};
